"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@icis/ui-kit");
var _focusTrapReact = _interopRequireDefault(require("focus-trap-react"));
var _Announcements = require("./Announcements.style");
var _List = _interopRequireDefault(require("./List"));
var _l10n = require("../../../../../../../l10n");
var _SubMenu = require("../../../../SubMenu/SubMenu.style");
const AnnouncementsFunctionality = _ref => {
  let {
    selected,
    announcements,
    id,
    onClose,
    locale
  } = _ref;
  const modal = React.useRef(null);
  const translate = (0, _l10n.getMessages)(locale);
  return (
    /*#__PURE__*/
    // @ts-ignore
    React.createElement(_focusTrapReact.default, {
      active: selected && modal.current,
      focusTrapOptions: {
        initialFocus: /* istanbul ignore next */() => modal.current,
        allowOutsideClick: true,
        returnFocusOnDeactivate: false
      }
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_SubMenu.SubMenuList, {
      id: id,
      ref: modal,
      tabIndex: -1,
      "data-test-id": "subMenu-".concat(id)
    }, /*#__PURE__*/React.createElement(_Announcements.TabCloseButton, {
      onClick: onClose,
      type: "button"
    }, /*#__PURE__*/React.createElement(_uiKit.Text.H6, null, translate('General.Close'))), /*#__PURE__*/React.createElement(_Announcements.HeaderSubMenuItem, {
      showing: selected,
      noSeparator: true,
      noHover: true,
      positionToLeft: true
    }, /*#__PURE__*/React.createElement(_SubMenu.SubMenuItemInner, {
      showing: selected,
      listLength: 2,
      index: 0
    }, /*#__PURE__*/React.createElement(_uiKit.Text.H4, null, translate('Announcements.Title')))), /*#__PURE__*/React.createElement(_List.default, {
      announcements: announcements,
      isOpen: selected
    }))))
  );
};
var _default = exports.default = AnnouncementsFunctionality;